import { Routes } from '@angular/router';
import { ActivateAccountComponent } from 'avn/modules/features/auth-check/activate-account/activate-account';
import { SignInComponent } from 'avn/modules/features/auth-check/sign-in/sign-in';
import { SignUpComponent } from 'avn/modules/features/auth-check/sign-up/sign-up';
import { AboutAvaanaComponent } from 'avn/modules/features/home/about-avaana/about-avaana';
import { HomeComponent } from 'avn/modules/features/home/home/home';
import { CollectionStatementsComponent } from 'avn/modules/features/terms/collection-statements/collection-statements';
import { CommunityGuidelinesComponent } from 'avn/modules/features/terms/community-guidelines/community-guidelines';
import { CustomerTermsComponent } from 'avn/modules/features/terms/customer-terms/customer-terms';
import { DisclaimerComponent } from 'avn/modules/features/terms/disclaimer/disclaimer';
import { PrivacyPolicyComponent } from 'avn/modules/features/terms/privacy-policy/privacy-policy';
import { ProviderTermsComponent } from 'avn/modules/features/terms/provider-terms/provider-terms';
import { SiteMapComponent } from 'avn/modules/features/terms/sitemap/sitemap';
import { NotFoundComponent } from 'avn/modules/shared/components/not-found/not-found';
import { LoginGuard } from 'avn/modules/shared/guards/login-gaurd';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [LoginGuard]
  },
  { path: 'notfound', component: NotFoundComponent },
  {
    path: 'login',
    component: SignInComponent
  },
  {
    path: 'maintenance',
    loadChildren: () => import('avn/modules/features/maintenance/maintenance.routes').then((m) => m.MAINTENANCE_ROUTES)
  },
  {
    path: 'reset-password/:slug/:token',
    component: ActivateAccountComponent
  },
  {
    path: 'profile',
    loadChildren: () => import('avn/modules/features/profile-new/profile-new.routes').then((m) => m.PROFILE_NEW_ROUTES)
  },
  {
    path: 'about-avaana',
    component: AboutAvaanaComponent
  },
  {
    path: 'sitemap',
    component: SiteMapComponent
  },
  {
    path: 'disclaimer',
    component: DisclaimerComponent
  },
  {
    path: 'collection-statements',
    component: CollectionStatementsComponent
  },
  {
    path: 'provider-terms',
    component: ProviderTermsComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'booking-terms',
    component: CustomerTermsComponent
  },
  {
    path: 'community-guidelines',
    component: CommunityGuidelinesComponent
  },
  {
    path: 'online/:service',
    data: {
      url_type: 'online'
    },
    loadChildren: () =>
      import('avn/modules/features/service-list/service-list.routes').then((m) => m.SERVICE_LIST_ROUTES)
  },
  {
    path: 'booking',
    loadChildren: () =>
      import('avn/modules/features/booking-flow/booking-flow.routes').then((m) => m.BOOKING_FLOW_ROUTES)
  },
  {
    path: 'confirm/:appointment_id',
    loadChildren: () =>
      import('avn/modules/features/booking-flow/booking-complete-page/booking-complete-page.routes').then(
        (m) => m.BOOKING_COMPLETE_PAGE_ROUTES
      )
  },
  {
    path: 'provider/:provider_name/:suburb',
    loadChildren: () =>
      import('avn/modules/features/new-provider/new-provider.routes').then((m) => m.NEW_PROVIDER_ROUTES)
  },
  {
    path: 'assistedbooking',
    loadChildren: () =>
      import('avn/modules/features/service-list/service-list.routes').then((m) => m.SERVICE_LIST_ROUTES)
  },
  {
    path: 'browse',
    loadChildren: () =>
      import('avn/modules/features/service-list/service-list.routes').then((m) => m.SERVICE_LIST_ROUTES)
  },
  {
    path: 'search',
    loadChildren: () =>
      import('avn/modules/features/service-list/service-list.routes').then((m) => m.SERVICE_LIST_ROUTES)
  },
  {
    path: 'link',
    loadChildren: () =>
      import('avn/modules/features/link-preferences/link-preferences.routes').then((m) => m.LINK_PREFERENCES_ROUTES)
  },
  // This route came from AuthCheckModule's own routing (AuthCheckRoutingModule), which was
  // eagerly imported (not lazy-loaded under a path prefix) and so never actually mounted reachably: 'path: ""'
  // here is always shadowed by the HomeComponent route above. Preserved as-is (pre-existing behavior, unrelated
  // to this migration) rather than fixed as part of eliminating the wrapping NgModules.
  { path: '', component: SignUpComponent },
  { path: '**', redirectTo: '/notfound' }
];
